import type React from 'react'

type Props = {
  text: string | React.ReactNode
  href?: string
  target?: '_self' | '_blank'
  type?: 'button' | 'submit' | 'reset'
  borderColor?: string
  bgColor?: string
  textSize?: 'text-sm' | 'text-xs' | 'text-xss'
  width?: string
  paddingY?: 'py-2' | 'py-3'
  disabled?: boolean
  classes?: string
  onClick?: () => void
}

export const Button = ({
  text,
  href,
  target = '_self',
  type = 'button',
  borderColor = 'border-main',
  bgColor = 'bg-main',
  textSize = 'text-sm',
  paddingY = 'py-3',
  width = 'w-11/12',
  disabled = false,
  classes,
  onClick,
}: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault()
      window.open(href, target, 'noopener')
    } else if (onClick) {
      onClick()
    }
  }

  return (
    <div className="text-center">
      <button
        type={type}
        name={type}
        disabled={disabled}
        className={`focus:outline-none rounded-full border-2 ${borderColor} ${bgColor} ${paddingY} ${textSize} font-bold ${bgColor === 'bg-main' ? 'text-sub' : ''} ${width} ${
          disabled ? 'opacity-[0.2]' : ''
        } ${classes && classes}`}
        onClick={handleClick}
      >
        {text}
      </button>
    </div>
  )
}
